import React, { useEffect } from "react";
import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material";

import upsl1 from "../../../images/upsl-1.jpeg";
import upsl2 from "../../../images/upsl-2.jpg";
import upsl3 from "../../../images/upsl-3.jpg";
import upsl4 from "../../../images/upsl-4.jpg";

const programFeatures = [
  "Organic learning",
  "Learning by doing",
  "Learning under pressure",
  "Learning by mentorship",
  "Learning in rigorous environments",
];

export default function UPSLMensTeam() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ bgcolor: "#070b14", color: "#f4f7fb" }}>
      <Box
        sx={{
          minHeight: { xs: "78vh", md: "86vh" },
          display: "flex",
          alignItems: "flex-end",
          backgroundImage: `linear-gradient(90deg, rgba(4, 8, 18, 0.92) 0%, rgba(4, 8, 18, 0.58) 48%, rgba(4, 8, 18, 0.18) 100%), url(${upsl4})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          pt: "100px",
          pb: { xs: 8, md: 12 },
        }}
      >
        <Container>
          <Stack spacing={3} maxWidth={780}>
            <Typography
              variant="overline"
              sx={{ color: "#ff4050", fontWeight: 800, letterSpacing: 2 }}
            >
              Atlantic United | Player Mentorship
            </Typography>
            <Typography variant="h1" sx={{ fontSize: { xs: "3rem", md: "5.5rem" }, lineHeight: 0.98 }}>
              UPSL Mens Team
            </Typography>
            <Typography variant="h5" sx={{ lineHeight: 1.45, maxWidth: 680 }}>
              An unmatched training and playing experience for youth players on Long Island.
            </Typography>
            <Button href="#upsl-contact" variant="contained" color="secondary" size="large" sx={{ alignSelf: "flex-start" }}>
              Enquire About The Program
            </Button>
          </Stack>
        </Container>
      </Box>

      <Box sx={{ py: { xs: 8, md: 13 }, bgcolor: "#f4f6f8", color: "#101827" }}>
        <Container>
          <Grid container spacing={{ xs: 6, md: 10 }} alignItems="center">
            <Grid item xs={12} md={8}>
              <Typography variant="overline" sx={{ color: "#d7192d", fontWeight: 800, letterSpacing: 2 }}>
                The opportunity
              </Typography>
              <Typography variant="h2" sx={{ mt: 1, mb: 3, fontSize: { xs: "2.2rem", md: "3.5rem" } }}>
                Learn the game at its next level.
              </Typography>
              <Typography variant="body1" sx={{ fontSize: "1.15rem", lineHeight: 1.8, fontWeight: 500 }}>
                The UPSL Mens Team is a mentorship program for select U16-U19 Atlantic United players. Players train and play games alongside older professional, semi-professional, and collegiate athletes, building the habits and resilience required for the next stage of the game.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box component="img" src={upsl2} alt="Atlantic United players training together" sx={{ width: "100%", display: "block", aspectRatio: "4 / 3", objectFit: "cover" }} />
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box sx={{ py: { xs: 8, md: 12 } }}>
        <Container>
          <Grid container spacing={3} alignItems="stretch">
            <Grid item xs={12} md={8}>
              <Stack spacing={3} sx={{ height: "100%", justifyContent: "center", px: { md: 3 } }}>
                <Typography variant="overline" sx={{ color: "#ff4050", fontWeight: 800, letterSpacing: 2 }}>
                  Led by Richie Nuttall
                </Typography>
                <Typography variant="h2" sx={{ fontSize: { xs: "2.2rem", md: "3.5rem" } }}>
                  Experience that opens the game up.
                </Typography>
                <Typography variant="body1" sx={{ fontSize: "1.1rem", lineHeight: 1.8, fontWeight: 500 }}>
                  Richie Nuttall led Hofstra Mens Soccer as head coach for 37 years. His vast experience in player development and recruitment at the collegiate and professional levels gives Atlantic United players direct access to a rare depth of knowledge, perspective, and standards.
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={6}>
                  <Box component="img" src={upsl1} alt="UPSL Mens Team players training" sx={{ width: "100%", display: "block", objectFit: "cover", objectPosition: "center" }} />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Box component="img" src={upsl3} alt="Players competing in a UPSL Mens Team match" sx={{ width: "100%", display: "block", objectFit: "cover", objectPosition: "center top" }} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: "#101827" }}>
        <Container>
          <Grid container spacing={{ xs: 6, md: 10 }} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="overline" sx={{ color: "#ff4050", fontWeight: 800, letterSpacing: 2 }}>
                Program features
              </Typography>
              <Typography variant="h2" sx={{ mt: 1, mb: 4, fontSize: { xs: "2.2rem", md: "3.5rem" } }}>
                Not for the faint hearted.
              </Typography>
              <Stack spacing={2}>
                {programFeatures.map((feature, index) => (
                  <Box key={feature} sx={{ display: "flex", gap: 2, alignItems: "center", borderBottom: "1px solid rgba(255,255,255,0.18)", pb: 2 }}>
                    <Typography sx={{ color: "#ff4050", fontWeight: 800, minWidth: 28 }}>{String(index + 1).padStart(2, "0")}</Typography>
                    <Typography variant="h6">{feature}</Typography>
                  </Box>
                ))}
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box id="upsl-contact" sx={{ py: { xs: 8, md: 10 }, bgcolor: "#d7192d", color: "white" }}>
        <Container>
          <Stack spacing={2}>
            <Typography variant="overline" sx={{ fontWeight: 800, letterSpacing: 2 }}>
              Contact the UPSL Mens Team
            </Typography>
            <Typography variant="h2" sx={{ fontSize: { xs: "2.2rem", md: "3.5rem" } }}>
              Frank Stagnitta
            </Typography>
            <Typography
              component="a"
              href="mailto:boys.doc@atlanticunitedsc.com"
              variant="h6"
              sx={{ color: "inherit", textDecorationColor: "rgba(255,255,255,0.65)" }}
            >
              boys.doc@atlanticunitedsc.com
            </Typography>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}
